var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"count"},[_vm._v(" "+_vm._s(_vm.chargeFee)+" "),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.$tc('common.unit', _vm.chargeFee)))])]),_c('div',{attrs:{"id":"paypal-button-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }